import React, { ReactNode } from "react";

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  children: ReactNode;
  size?: "display" | "xl" | "lg" | "md" | "sm" | "xs" | "xxs" | "xxxs";
  style?: React.CSSProperties;
}

const Heading: React.FC<HeadingProps> = ({
  children,
  size = "xs",
  style,
  ...props
}) => (
  <h2 className={`heading-${size}`} style={style} {...props}>
    {children}
  </h2>
);

export default Heading;
